export default "__VITE_ASSET__1a19e283__"